import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { UserService } from '../../../../core/services/user.service';
import { Observable } from 'rxjs';
import { User } from '../../../../interfaces/user';
import { EnableMfaModalComponent } from 'src/app/shared/components/enable-mfa-modal/enable-mfa-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteModalComponent } from 'src/app/shared/components/delete-modal/delete-modal.component';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { PERMISSIONS, PermissionService } from 'src/app/core/services/permission.service';

@Component({
  selector: 'app-user-drop-down',
  templateUrl: './user-drop-down.component.html',
  styleUrls: ['./user-drop-down.component.scss']
})
export class UserDropDownComponent implements OnInit {

  public user$: Observable<User> = this.userService.user$;

  readonly permissions = PERMISSIONS;

  constructor(
    private authService: AuthService,
    protected modal: NgbModal,
    private permissionService: PermissionService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private userService: UserService) {
  }

  ngOnInit() {
  }

  logout() {
    this.authService.logout();
  }

  enableMfa() {
    const modal = this.modal.open(EnableMfaModalComponent);
    modal.componentInstance.text = {
      header: 'Skonfiguruj logowanie wieloskładownikowe',
      body: 'body!!!',
      submit: 'APPLY',
    };
    modal.componentInstance.deleteFunc = () => {
      return {};
    };
    return modal.result;
  }

  disableMfa() {
    const modal = this.modal.open(DeleteModalComponent);
    modal.componentInstance.text = {
      header: 'DELETE',
      body: this.translate.instant('DELETE_PROMPT', { name: 'Multi-Factor Authentication'}),
      submit: 'APPLY',
    };
    modal.componentInstance.deleteFunc = () => {
      return this.authService.disableMfa().subscribe(() => this.toastr.info(`Pomyślnie wyłączono uwierzytelnianie wieloskładownikowe`));
    };
    return modal.result;
  }

  get showMfa() {
    return this.permissionService.hasPermission(this.permissions.USER_MFA);
  }
}
